import React, { useState } from "react";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import Modal from "@mui/material/Modal";
import Pitch from "../../assets/icons/Pitch.png";
import FinalThird from "../../assets/icons/FinalThird.png";
import styles from "./style.module.css";

interface PitchOptionProps {
  isOpen: boolean;
  selectedPitchOption: string;
  onClose: (selectedOption: string) => void;
}

const PitchOptions: React.FC<PitchOptionProps> = ({ isOpen, selectedPitchOption, onClose }) => {
  const [open, setOpen] = useState(isOpen);
  const [selectedOption, setSelectedOption] = useState<string>(selectedPitchOption);

  const handleCloseModal = (selectedOption: string) => {
    setOpen(false);
    onClose(selectedOption); // Call the method passed as prop
  };

  const handleSelectOption = (event: React.MouseEvent<HTMLElement>, newOption: string) => {
    if (newOption !== null) {
      setSelectedOption(newOption);
      handleCloseModal(newOption);
    } else {
      handleCloseModal(selectedOption);
    }
  };

  const getButtonClass = (option: string) => {
    return selectedOption === option ? styles.selectedButton : styles.unselectedButton;
  };

  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className={styles.modalContainer}
    >
      <ToggleButtonGroup
        value={selectedOption}
        exclusive
        onChange={handleSelectOption}
        aria-label="pitch options"
        orientation="vertical"
        sx={{ gap: "10px" }}
      >
        <ToggleButton value="WholePitch" aria-label="whole pitch" className={`${styles.toggleButton} ${getButtonClass("WholePitch")}`}>
          <img src={Pitch} alt="Whole Pitch" />
          <span className={styles.toggleButtonText}>WHOLE PITCH</span>
        </ToggleButton>
        <ToggleButton value="FinalThird" aria-label="final third" className={`${styles.toggleButton} ${getButtonClass("FinalThird")}`}>
          <img src={FinalThird} alt="Final Third" />
          <span className={styles.toggleButtonText}>FINAL THIRD</span>
        </ToggleButton>
      </ToggleButtonGroup>
    </Modal>
  );
};

export default PitchOptions;
